var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { LinearProgress as MuiLinearProgress, } from '@mui/material';
var LinearProgress = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'determinate' : _b, _c = _a.value, value = _c === void 0 ? 0 : _c, _d = _a.color, color = _d === void 0 ? 'info' : _d, props = __rest(_a, ["variant", "value", "color"]);
    return (React.createElement(MuiLinearProgress, __assign({ variant: variant, value: value, color: color }, props)));
};
export default LinearProgress;
//# sourceMappingURL=LinearProgress.js.map